import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme:Theme) => ({
    marginBottom10: {
        marginBottom:10
      },
      paddingRight40:{
        paddingRight:40,
        marginTop:20,
      },
      formControl: {
        marginTop:15,
        minWidth:340,
      },
      infomation:{
        fontSize:20,
        fontWeight:"bold",
      },
      marginTop10:{
        marginTop:20
      },
      margin10:{
        marginTop:10
      },
      marginLeft10:{
        marginLeft:20
      },
      tabPannel:{
        marginTop:40
      },
      font:{
        fontSize:20,
      },
      marginTop5:{
        marginTop:6
      },
      marginTop15:{
        marginTop:15
      },
      passwordIcon:{
        marginLeft:10,
        paddingTop:0
      },
      copyImage:{width:16,height:16,},
      copyButton:{
        border:'1px solid #E08489',
        width:28,
        height:28,
        marginTop:30,
        '&:hover':{
          borderColor:'#C4122F'
        }
      },
      copyButton22:{
        border:'1px solid #E08489',
        width:28,
        height:28,
        marginTop:22,
        '&:hover':{
          borderColor:'#C4122F'
        }
      },
      alertToast:{ height: 42,width:150,marginLeft:10,marginTop:25},
      total:{ marginLeft: 15,paddingTop:12,fontWeight:'bold'},
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      selectDropdown: {
        //margin: theme.spacing(1.4),
      minWidth:380,
        },
      buttonStyle:{
          marginTop:25
        },
    ftpName:{fontSize:16,fontWeight:'inherit',color:'inherit',marginTop: 15,},
    ftpUrl:{fontSize:16,fontWeight:'inherit',color:'inherit',marginTop: 15,marginLeft:10},
    ftpPort:{fontSize:16,fontWeight:'inherit',color:'inherit',marginTop: 15,marginLeft:30},
    sftpPort:{fontSize:16,fontWeight:'inherit',color:'inherit',marginTop: 15,marginLeft:23}
}))